export default {
  name: "sbtoggler",

  box: 20,

  svg: `
  <path
  d="M18.75 17.5H1.25001C0.559623 17.5 0 16.9403 0 16.25C0 15.5597 0.559623 15 1.25001 15H18.75C19.4404 15 20 15.5597 20 16.25C20 16.9403 19.4404 17.5 18.75 17.5Z"
  fill="fillcolor"
/>
<path
  d="M18.75 11.25H1.25001C0.559623 11.25 0 10.6904 0 10C0 9.30967 0.559623 8.75 1.25001 8.75H18.75C19.4404 8.75 20 9.30962 20 10C20 10.6904 19.4404 11.25 18.75 11.25Z"
  fill="fillcolor"
/>
<path
  d="M18.75 5.00002H1.25001C0.559623 5.00002 0 4.44039 0 3.75001C0 3.05962 0.559623 2.5 1.25001 2.5H18.75C19.4404 2.5 20 3.05962 20 3.75001C20 4.44039 19.4404 5.00002 18.75 5.00002Z"
  fill="fillcolor"
/>
`,
};
